import { useLocalizationContext } from '@im/react-localization';
import { useSearchParams } from 'react-router-dom';
import { regionMapping } from 'src/config/';

export const useGetRegion = () => {
  const [searchParams] = useSearchParams();
  const l10nContext = useLocalizationContext();
  const { locale } = l10nContext;
  const countryCode = searchParams.get('countryCode') ?? locale.split('-')[1];
  return (
    Object.entries(regionMapping).find(([_, countries]) =>
      countries.includes(countryCode)
    )?.[0] ?? ''
  );
};
